import { isIframe } from 'iframe-support'
import $ from 'jquery'
/**
 * Handy function to scroll the viewport so that the "Send Money" and cancel button are at
 * the bottom of the page.
 */
export function scrollToThisElement(whereToScrollTo, addedValue, setFocus) {
  // if the app is being loaded in an iframe, we don't want to scroll their app
  // or some external flows (at least Outlook) do not have a cancel link
  if (isIframe() || !whereToScrollTo) {
    return
  }
  window.scrollTo(0, 0)
  // all variables represent pixel values
  const docTopToElementTop = $(whereToScrollTo).offset().top
  const mostOfViewportHeight = window.innerHeight - 150
  const desiredTopOfViewport = docTopToElementTop - mostOfViewportHeight
  const scrollValue = addedValue
    ? desiredTopOfViewport + addedValue
    : desiredTopOfViewport
  $('html, body').animate(
    {
      scrollTop: scrollValue,
    },
    800
  )
  if (setFocus) {
    setFocusToHtmlElement(whereToScrollTo)
  }
}

/**
 * Check if an element is not visible in the viewport and scroll it into view.
 * NOTE: contrary to "scrollToThisElement" (see above) this method lets the
 *       browser handle scrolling natively instead of manually scrolling the
 *       window to an element
 * @docs https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
 * @param {HTMLElement} element
 * @param {Object} options
 */
export function scrollElementIntoViewport(element, options) {
  const {
    behavior = 'smooth',
    block = 'center', // vertical alignment
    inline = 'nearest', // horizontal alignment
  } = options || {}

  if (element && element.scrollIntoView) {
    // NOTE: this will also run inside the iframes!
    element.scrollIntoView({ behavior, block, inline })
  }
}

/**
 * Calculates navigation height. Currently used for merchant accounts
 * with double header row experience. For consumer header, default to 72.
 */
export function getNavHeight() {
  const merchantNav = document.getElementById(
    'merchant-header-main-wrapper-internal'
  )
  const dw2Nav = document.querySelector('.cw_navbar__mainnav')
  const dw2NavMobile = document.querySelector('.cw_navbar_mobile')
  let navHeight = 72 // Consumer header is fixed to 72
  if (merchantNav) {
    navHeight = merchantNav.offsetHeight
  }
  if (dw2Nav) {
    navHeight = dw2Nav.offsetHeight
  }
  if (
    dw2NavMobile &&
    window.getComputedStyle(dw2NavMobile).display !== 'none'
  ) {
    navHeight = dw2NavMobile.offsetHeight
  }
  return navHeight
}

export function setFocusToHtmlElement(elementToFocus) {
  $(elementToFocus).focus()
}
